<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             size="lg"
             @ok="handleOk">

            <form @submit.stop.prevent="handleOkDetalhe" @keydown="form.errors.clear($event.target.name)">
            <b-row no-gutters>
                <b-col>
                    <b-form-text>Código</b-form-text>
                        <b-form-input type="text"
                                    placeholder="Código"
                                    v-model="form.cd"
                                    name="cd"
                                    >
                        </b-form-input>
                    <b-form-feedback v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>
                </b-col>
               <b-col>
                  <b-form-text>Descrição</b-form-text>
                      <b-form-input type="text"
                                    placeholder="Descrição"
                                    v-model="form.descr"
                                    name="descr"
                                    >
                      </b-form-input>
                  <b-form-feedback v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>
                </b-col>
                <b-col>
                   <b-form-text>Tag</b-form-text>
                       <b-form-input type="text"
                                     placeholder="Tag"
                                     v-model="form.tag"
                                     name="tag"
                                     >
                       </b-form-input>
                   <b-form-feedback v-text="form.errors.get('tag')" v-if="form.errors.has('tag')"></b-form-feedback>
                 </b-col>
                 <b-col>
                     <b-form-text>Ordem</b-form-text>
                          <b-form-input type="text"
                                        placeholder="Ordem"
                                        v-model="form.ordem"
                                        name="ordem"
                                        >
                          </b-form-input>
                  <b-form-feedback v-text="form.errors.get('ordem')" v-if="form.errors.has('ordem')"></b-form-feedback>
                </b-col>
                  <b-col>
                      <b-form-text>Campo Fixo</b-form-text>
                          <b-form-input type="text"
                                        placeholder="Campo Fixo"
                                        v-model="form.campo_fixo"
                                        name="campo_fixo"
                                        >
                          </b-form-input>
                  <b-form-feedback v-text="form.errors.get('campo_fixo')" v-if="form.errors.has('campo_fixo')"></b-form-feedback>
                </b-col>
            </b-row>
            <b-row no-gutters>
            <b-col>
                <b-form-text>Tamanho</b-form-text>
                    <b-form-input type="text"
                                placeholder="Tamanho"
                                v-model="form.tamanho"
                                name="tamanho"
                                >
                    </b-form-input>
                <b-form-feedback v-text="form.errors.get('tamanho')" v-if="form.errors.has('tamanho')"></b-form-feedback>
            </b-col>
            <b-col>
                <b-form-text>Decimais</b-form-text>
                    <b-form-input type="text"
                                placeholder="Decimais"
                                v-model="form.decimais"
                                name="decimais"
                                >
                    </b-form-input>
                <b-form-feedback v-text="form.errors.get('decimais')" v-if="form.errors.has('decimais')"></b-form-feedback>
            </b-col>
            <b-col>
                <b-form-text>Máscara Data</b-form-text>
                    <b-form-input type="text"
                                placeholder="Máscara Data"
                                v-model="form.mascara_data"
                                name="mascara_data"
                                >
                    </b-form-input>
                <b-form-feedback v-text="form.errors.get('mascara_data')" v-if="form.errors.has('mascara_data')"></b-form-feedback>
            </b-col>
            <b-col>
                <b-form-text>Completa Esquerda</b-form-text>
                    <b-form-input type="text"
                                placeholder="Completa Esquerda"
                                v-model="form.completa_esquerda"
                                name="completa_esquerda"
                                >
                    </b-form-input>
                <b-form-feedback v-text="form.errors.get('completa_esquerda')" v-if="form.errors.has('completa_esquerda')"></b-form-feedback>
            </b-col>
            <b-col>
                <b-form-text>Completa Direita</b-form-text>
                    <b-form-input type="text"
                                placeholder="Completa Direita"
                                v-model="form.completa_direita"
                                name="completa_direita"
                                >
                    </b-form-input>
                <b-form-feedback v-text="form.errors.get('completa_direita')" v-if="form.errors.has('completa_direita')"></b-form-feedback>
            </b-col>
        </b-row>
        <b-row no-gutters>
            <b-col md="2" sm="2">
                <label>Tipo campo</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.tp_campo"
                        :options="optionsLivTpCampo"
                        name="tp_campo"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                <b-form-feedback v-text="form.errors.get('tp_campo')" v-if="form.errors.has('tp_campo')"></b-form-feedback>
            </b-col>
            <b-col md="2" sm="2">
                <label>Formato campo</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.formato_campo"
                        :options="optionsLivFormatoCampo"
                        name="formato_campo"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                <b-form-feedback v-text="form.errors.get('formato_campo')" v-if="form.errors.has('formato_campo')"></b-form-feedback>
            </b-col>
            <b-col md="2" sm="2">
                <label>Obrigatório</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.obrigatorio"
                        :options="optionsLivObrigatorio"
                        name="obrigatorio"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                <b-form-feedback v-text="form.errors.get('obrigatorio')" v-if="form.errors.has('obrigatorio')"></b-form-feedback>
            </b-col>
            <b-col md="2" sm="2">
                <label>Status</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.status"
                        :options="optionsLivStatus"
                        name="status"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                <b-form-feedback v-text="form.errors.get('status')" v-if="form.errors.has('status')"></b-form-feedback>
            </b-col>
            <b-col>
              <b-form-text>Grupo Dados Campo</b-form-text>
              <multiselect v-model="grupoDadosCampoSelected"
              :options="optionsGrupoDadosCampo"
              track-by="value"
              label="label"
              :hide-selected="true"
              placeholder="Selecione"
              tag-placeholder="Selecionar"
              select-label="Selecionar"
              selected-label="Selecionado"
              deselect-label="Remover"
              ></multiselect>
              <b-form-feedback v-text="form.errors.get('bgrpdadc_id')" v-if="form.errors.has('bgrpdadc_id')"></b-form-feedback>
            </b-col>
        </b-row>
      </form>

        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>

export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      optionsLivStatus: [],
      optionsLivTpCampo: [],
      optionsLivFormatoCampo: [],
      optionsLivObrigatorio: [],
      optionsGrupoDadosCampo: [],
      grupoDadosCampoSelected: [],
      form: new Form({ cd: '',
                    descr: '',
                    tag: '',
                    ordem: '',
                    tp_campo: 0,
                    bgrpdadc_id: '',
                    campo_fixo: '',
                    formato_campo: 0,
                    tamanho: '',
                    decimais: '',
                    obrigatorio: 0,
                    status: 0,
                    mascara_data: '',
                    completa_esquerda: '',
                    completa_direita: '',
                    laygrp_id: '',
                    blgdet_id: ''

                   }),
     helpForm: new Form({statusRecord: [], params: []}),
    fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    grupoDadosCampoSelected(obj) {console.log(obj);
        this.form.bgrpdadc_id = obj.value;
    }
},
mounted() {
    this.getLivGeral();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.lgdet_id);
        }
    },
    onCreate (data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.grupoDadosCampoSelected = [];
      this.form.reset();
      this.form.laygrp_id = data.laygrp_id;
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.grupoDadosCampoSelected = [];
      this.form.reset();
      this.form.cd = data.cd;
      this.form.descr = data.descr;
      this.form.tag = data.tag;
      this.form.ordem = data.ordem;
      this.form.campo_fixo = data.campo_fixo;
      this.form.tamanho = data.tamanho;
      this.form.decimais = data.decimais;
      this.form.mascara_data = data.mascara_data;
      this.form.completa_esquerda = data.completa_esquerda;
      this.form.completa_direita = data.completa_direita;
      this.form.status = data.status.valor;
      this.form.tp_campo = data.tp_campo.valor;
      this.form.formato_campo = data.formato_campo.valor;
      this.form.obrigatorio = data.obrigatorio.valor;
      if(data.b_grupo_dados_campo!==null)
      {
          this.grupoDadosCampoSelected = { label: data.b_grupo_dados_campo.b_grupo_dados.cd+" - "+data.b_grupo_dados_campo.b_grupo_dados.descr+" - "+data.b_grupo_dados_campo.cd+" - "+data.b_grupo_dados_campo.descr, value: data.b_grupo_dados_campo.bgrpdadc_id };
      }
      this.form.lgdet_id = data.lgdet_id;
      this.form.laygrp_id = data.laygrp_id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/'+this.rota+'/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/'+this.rota+'/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });

    },
    getLivGeral()
    {
        this.helpForm.get('/api/layoutgrupodetalhe/jsonlistgeral').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.tp_campo.forEach((obj)=>
            {
                this.optionsLivTpCampo.push({ text: obj.descr, value: obj.valor })
            })
            response.formato_campo.forEach((obj)=>
            {
                this.optionsLivFormatoCampo.push({ text: obj.descr, value: obj.valor })
            })
            response.obrigatorio.forEach((obj)=>
            {
                this.optionsLivObrigatorio.push({ text: obj.descr, value: obj.valor })
            })
            response.grupo_dados.forEach((obj)=>
            {
                this.optionsGrupoDadosCampo.push({ label: obj.b_grupo_dados.cd+" - "+obj.b_grupo_dados.descr+" - "+obj.cd+" - "+obj.descr, value: obj.bgrpdadc_id })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
